import localStorageService from '../../utils/services/localStorage/localStorage';

// Types
import { MilanoteApplicationMode } from '../../../common/platform/platformTypes';

export const LAST_APP_MODE_KEY = 'milanote.lastAppMode';
export const getLastAppMode = (): MilanoteApplicationMode | null => {
    const value = localStorageService.getItem(LAST_APP_MODE_KEY);
    if (!value) return null;

    // TODO - Remove this >2 months after release (>= 15/06/25)
    if (value === 'mobileLegacy') return MilanoteApplicationMode.mobile;

    return value as MilanoteApplicationMode;
};

export const setLastAppMode = (appMode: MilanoteApplicationMode) => {
    localStorageService.setItem(LAST_APP_MODE_KEY, appMode);
};
